function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Notification"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.916704 11.4893V11.3069C0.943475 10.767 1.11651 10.2438 1.41798 9.79142C1.91977 9.24797 2.26327 8.582 2.41244 7.8634C2.41244 7.308 2.41244 6.74467 2.46095 6.18927C2.71159 3.51543 5.35541 1.66675 7.9669 1.66675H8.03158C10.6431 1.66675 13.2869 3.51543 13.5456 6.18927C13.5941 6.74467 13.5456 7.308 13.586 7.8634C13.7372 8.58367 14.0804 9.2517 14.5805 9.79935C14.8842 10.2478 15.0575 10.769 15.0818 11.3069V11.4814C15.0998 12.2068 14.85 12.9141 14.3784 13.4729C13.7551 14.1263 12.9094 14.5328 12.0014 14.6154C9.33851 14.9011 6.65188 14.9011 3.98904 14.6154C3.08197 14.5292 2.23748 14.1233 1.61202 13.4729C1.14768 12.9137 0.901216 12.2106 0.916704 11.4893Z",
    stroke: "#3674CB",
    style: {
      stroke: "#3674CB",
      stroke: "color(display-p3 0.2118 0.4549 0.7961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    d: "M5.96094 17.3765C6.377 17.8987 6.98799 18.2367 7.65868 18.3156C8.32937 18.3945 9.00447 18.2079 9.53454 17.797C9.69758 17.6755 9.84428 17.5342 9.97114 17.3765",
    stroke: "#3674CB",
    style: {
      stroke: "#3674CB",
      stroke: "color(display-p3 0.2118 0.4549 0.7961)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.a37c89483fe26e97a34e3f94fefcc5aa.svg";
export { ForwardRef as ReactComponent };